const measurementTypesInfo = state => state.measurementTypesInfo
const measurementCharts = state => state.measurementCharts

export default {
  measurementTypesInfo,
  measurementCharts
}
